import { render, staticRenderFns } from "./PluginMapSettingsPrescriber.vue?vue&type=template&id=7b7e6287&scoped=true&"
import script from "./PluginMapSettingsPrescriber.vue?vue&type=script&lang=ts&"
export * from "./PluginMapSettingsPrescriber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7e6287",
  null
  
)

export default component.exports